/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import BTPlogo from '../images/BTP_circle-72.png'

const Header = ({ siteTitle, activeMenu }) => (
  <header id="home">
    <div className="container-fluid">
      <div className="header d-lg-flex justify-content-between align-items-center py-3 px-sm-3">
        <div id="logo">
          <Link to="/">
            <span className="logo mr-2">
              <img alt={'Black Tech Pipleline logo'} src={BTPlogo} />
            </span>
            <span sx={{ color: 'black' }}>Black Tech Pipeline</span>
          </Link>
        </div>

        <div className="nav_w3ls">
          <nav>
            <label htmlFor="drop" className="toggle">
              Menu
            </label>
            <input type="checkbox" id="drop" />
            <ul className="menu">
              <li>
                <Link
                  to="/"
                  sx={{ color: activeMenu === 'index' ? 'primary' : '' }}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  sx={{ color: activeMenu === 'about' ? 'primary' : '' }}
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/jobs"
                  sx={{ color: activeMenu === 'jobs' ? 'primary' : '' }}
                >
                  Job Board
                </Link>
              </li>
              <li>
                <Link
                  to="/events"
                  sx={{ color: activeMenu === 'events' ? 'primary' : '' }}
                >
                  Events
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/resources"
                  sx={{ color: activeMenu === 'resources' ? 'primary' : '' }}
                >
                  Resources
                </Link>
              </li> */}
              <li>
                <Link
                  to="/contact"
                  sx={{ color: activeMenu === 'contact' ? 'primary' : '' }}
                >
                  Contact
                </Link>
              </li>
              {/* <li>
                <a
                  href="https://blacktechpipeline.myshopify.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Shop
                </a>
              </li> */}
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
